export function interpolateColor(from: string, to: string, factor: number) {
  // simple linear interpolation between two hex colors
  const hexToRgb = (hex: string) => {
    let c = hex.replace("#", "");
    if (c.length === 3)
      c = c
        .split("")
        .map((x) => x + x)
        .join("");
    const num = parseInt(c, 16);
    return [num >> 16, (num >> 8) & 0xff, num & 0xff];
  };
  const rgbToHex = (rgb: number[]) =>
    "#" +
    rgb
      .map((x) => {
        const h = x.toString(16);
        return h.length === 1 ? "0" + h : h;
      })
      .join("");
  const a = hexToRgb(from);
  const b = hexToRgb(to);
  const result = a.map((v, i) => Math.round(v + (b[i] - v) * factor));
  return rgbToHex(result as number[]);
}
